<template>
  <v-app>
    <v-navigation-drawer
        v-if="isLogged"
        v-model="drawer"
        app
        clipped
        class="pt-4"
    >
      <tree_menu/>
    </v-navigation-drawer>
    <v-app-bar
        v-if="isLogged"
        app
        clipped-left
        dark
        color="blue"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>

  <div class="d-flex flex-column justify-space-between align-center">
  <v-img src="/assets/logo.gif" class="mt-0" width="100px"></v-img>
  </div>
      <v-toolbar-title class="pl-2">
        РКЦ-CRM {{ currentRouteName }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

        <span v-if="!isAuth">
                <router-link to="/Login" class="routerlink">Вход</router-link>
                <router-link to="/Register" class="routerlink">регистация</router-link>
            </span>
        <span v-else>
        <v-btn
            icon
            to="/user"
        >
            <v-icon>mdi-account-circle</v-icon>
        </v-btn>
            <v-btn
                icon
                @click="logout"
            >
            <v-icon>mdi-export</v-icon>
        </v-btn>
    </span>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>

  </v-app>
</template>


<script>
import LeftMenu from "../components/left-menu/DrawerMenu";
import tree_menu from "../components/tree_menu/"

export default {
  name: "App",
  components: {
    LeftMenu,
    tree_menu
  },
  data: () => ({
    drawer: true
  }),
  mounted() {
    // Echo.channel('erkc.ws.event')
    //     .listen('TestEvent', function (e)  {
    //       console.log('ReportSended: '+e)
    //     });
  },
  computed: {
    isLogged() {
      return true
    },
    currentRouteName() {
      if (this.$route.name !== 'home') {
        if (this.$route.meta.title === undefined) {
          return '/ ' + '404'
        }
        return '/ ' + this.$route.meta.title
      }
    },
      isAuth() {
          return this.$store.getters['auth/isAuth']
      },
  },
  methods: {
      async logout() {
          console.log(this.$store)
          await this.$store.dispatch('auth/logout')
          await this.$router.push('Login')
      },
  }
}
</script>

<style scoped>
.v-application a {
    color: white;
    text-decoration: none;
    font-size: 18px;
}
</style>
